<template slot="bills" slot-scope="props">
  <tr
    style="cursor: pointer"
    :class="{ 'blue lighten-5': updated, 'green lighten-5': created, 'red lighten-5': credit}"
    @click="editBill()"
  >
    <td @click.stop>
      <v-checkbox v-model="selected" :color="$store.state.global.pages.billing.color" hide-details></v-checkbox>
    </td>

    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span v-if="header.type == 'count'">{{ getObjectPath(header.value, bill).length || "-" }}</span>

      <span
        v-if="header.type == 'date'"
      >{{ makeShortDate(getObjectPath(header.value, bill)) || "-" }}</span>
      <span v-if="header.type == 'time'">{{ makeTime(getObjectPath(header.value, bill)) || "-" }}</span>
      <span
        v-if="header.type == 'num'"
      >{{ displayDecimal(getObjectPath(header.value, bill),header.decimals) || "-" }}</span>
      <span
        v-if="header.type == 'curr' "
      >{{ !!getObjectPath(header.value, bill) ? `$${displayDecimal(getObjectPath(header.value, bill),header.decimals)}` : "-" || "" }}</span>
      <span v-if="header.type == 'text'">{{ getObjectPath(header.value, bill) || "-" }}</span>

      <!--ACTIONS COLUMN -->
      <div
        v-if="header.type == 'action' && userAuthClass"
        class="justify-center layout px-0"
        @click.stop
      >
        <!-- TRIP OPTIONS MENU -->
        <v-menu bottom left :disabled="closed">
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <!-- <basic-list-tile title="Bill Summary" :color="$store.state.global.pages.billing.color"
                        :icon="$store.state.global.pages.billing.icon"
                        :onClick="viewSummaryDialog">
            </basic-list-tile>-->
            <basic-list-tile title="Edit" icon="edit" :onClick="editBill"></basic-list-tile>
            <v-divider inset></v-divider>
            <basic-list-tile
              color="red lighten-3"
              title="Delete"
              icon="delete"
              :onClick="deleteBill"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!--END ACTIONS COLUMN -->
    </td>
    <!-- END CELLS -->

    <!--  DIALOGS  -->
    <!-- Bill edit dialog -->
    <v-dialog lazy v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false">
      <edit-bill @close="editDialog = false" :bill="bill"></edit-bill>
    </v-dialog>
    <!--DELETE PROMPT DIALOG -->
    <v-dialog lazy v-model="deleteDialog" max-width="700px" @keydown.esc="adjustmentDialog = false">
      <invoice-delete-prompt
        @close="deleteDialog = false"
        :invoice="bill"
        invoiceType="bill"
        text="Delete Bill"
      ></invoice-delete-prompt>
    </v-dialog>
  </tr>
</template>

<script>
import EditBill from '@/components/bills/editBill'
import FormatDates from '@/services/mixins/formatDates'
import Store from '@/store/computed/storeHelpers'
import DocketService from '@/services/requests/docketService'

import CreatedUpdatedRows from '@/services/mixins/createdUpdatedRows'
import RowDisplayMethods from '@/services/mixins/rowDisplayMethods'
import InvoiceDeletePrompt from '@/components/rctis/invoiceDeletePrompt'
export default {
  mixins: [FormatDates, CreatedUpdatedRows, RowDisplayMethods],
  data() {
    return {
      prefix: 'bill',
      editDialog: false,
      deleteDialog: false,
      actionConfirmationDialog: false,
      summaryDialog: false,
      actionsMenu: false,
      currentNotes: '',
      fieldData: {}
    }
  },
  methods: {
    actionComplete() {
      this.fieldData = {}
      this.actionConfirmationDialog = false
    },
    deleteBill() {
      this.deleteDialog = true
    },
    editBill() {
      if (!this.closed) this.editDialog = true
    },
    viewSummaryDialog() {
      this.summaryDialog = true
    },
    confirmUpdateBillField(payload) {
      this.fieldData = payload
      this.currentNotes = this.bill[payload.notesField]
      this.actionConfirmationDialog = true
    }
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', { value: val, object: this.bill })
      }
    },
    credit() {
      return this.bill.type == 'CREDIT'
    },
    closed() {
      return this.status == 'CLOSED'
    }
  },
  props: {
    bill: Object,
    headers: Array,
    value: Boolean
  },
  components: {
    EditBill,
    InvoiceDeletePrompt
  }
}
</script>

<style>
.v-input--selection-controls .v-input__slot {
  margin-bottom: 3px;
}
</style>
